import { DataProvider } from 'react-admin';
import { ProgressOrderInfoInternalResponse } from './types/orders';
import { ordersProxy } from './apiGateway';

export const ordersDataProvider: DataProvider = {
    getList: async (resource, params) => {
        // Для заказов getList не используется, так как у нас только поиск по ID/номеру
        return Promise.resolve({
            data: [],
            total: 0,
        });
    },

    getOne: async (resource, params) => {
        const { id } = params;
        
        try {
            const responseData = await ordersProxy.getOne(id);
            
            // API возвращает {success: true, body: {...}}
            const data: ProgressOrderInfoInternalResponse = responseData.body;
            
            const result = {
                id: id, // Используем исходный id для поиска
                ...data,
            };
            
            return {
                data: result as any,
            };
        } catch (error) {
            console.error('Error fetching order:', error);
            throw new Error('Ошибка при получении информации о заказе');
        }
    },

    getMany: () => Promise.reject('Not implemented'),
    getManyReference: () => Promise.reject('Not implemented'),
    create: () => Promise.reject('Not implemented'),
    update: () => Promise.reject('Not implemented'),
    updateMany: () => Promise.reject('Not implemented'),
    delete: () => Promise.reject('Not implemented'),
    deleteMany: () => Promise.reject('Not implemented'),
};
